import AMapLoader from '@amap/amap-jsapi-loader';
import { GPSTransform, PERCISION } from '@client/helper/gps';
import { useSessionStorage } from '@vueuse/core';
const sessionState = useSessionStorage('isWGS84', 0);
const AMAP_KEY = '46a432e368b5725cb82ef5164c9a5cec';
const VERSION = '2.1Beta';
let MapConstructor;
let godvMapInstance;

export async function getGodvInstance({ id, lang, theme, showBasicMap } = {}) {
  if (godvMapInstance) {
    return Promise.resolve([godvMapInstance, MapConstructor]);
  }

  await getGodvMapConstructor();
  godvMapInstance = new MapConstructor.Map(id, {
    lang: lang === 'zh-CN' ? 'zh_cn' : 'en',
    mapStyle: theme === 'theme-dark' ? 'amap://styles/darkblue' : 'amap://styles/normal',
    layers: showBasicMap ? undefined : [],
    terrain:false,
    features:['bg','point','road'],
    pitchEnable: true, 
    viewMode: '3D',
  });
  return [godvMapInstance, MapConstructor];
}

export function getGodvMapConstructor() {
  if (MapConstructor) {
    return Promise.resolve(MapConstructor);
  }

  return AMapLoader.load({
    key: AMAP_KEY,
    version: VERSION,
    plugins: ['AMap.Geocoder']
  }).then((res) => {
    MapConstructor = res;
    return MapConstructor;
  });
}


export async function aMapPromiseConvertFrom(points) {
  const GodvMap = await getGodvMapConstructor();
  const isWGS84=sessionState.value;
  if (points.length === 0) return Promise.resolve();
  const res = points.map((point) => {
    const [gpsLon, gpsLat] = point;
    if(isWGS84){
      return new GodvMap.LngLat(gpsLon, gpsLat);
    }else{  
      const { lat = 0, lon: lng = 0 } = GPSTransform.gcj_encrypt(gpsLat, gpsLon);
      return new GodvMap.LngLat(lng, lat);
    }
    
   
  });
  return res;
}

/**
 * 转换成高德地图坐标
 * @param {Array} points 原始gps数据
 * @returns Promise
 */
export function convertToAMapCoordinate(points) {
  if (points.length === 0) return Promise.resolve([]);

  const convertedCoordinates = Object.create(null);
  
  const normalizePoints = Array.isArray(points[0]) ? points : [points];

  const unResolvedPoints = normalizePoints.filter((point) => !convertedCoordinates[`${point[0]}_${point[1]}`]);

  return aMapPromiseConvertFrom([...unResolvedPoints])
    .then((result) => {
      unResolvedPoints.forEach((point, index) => {
        convertedCoordinates[`${point[0]}_${point[1]}`] = result[index];
      });
    })
    .then(() => {
      return normalizePoints.map((point) => convertedCoordinates[`${point[0]}_${point[1]}`]);
    });
}
